module.exports = __webpack_public_path__ + "media/common/fonts/rs-plugin/revicons/revicons-dade77d9f4aa73ef2cc9d4f1345ac6d0.svg";